export enum BrandingResourceProperties {
  Source = 'source',
  BrandingResourceType = 'brandingResourceType',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  Profile = 'profile',
}
export enum BrandingResourceMetaProperties {
  ProfileId = 'Profile-id',
  ProfileVersion = 'Profile-version',
}
